"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResourceContext = void 0;
var React = __importStar(require("react"));
var resource_context_1 = require("./resource-context");
Object.defineProperty(exports, "useResourceContext", { enumerable: true, get: function () { return resource_context_1.useResourceContext; } });
function ResourceContextPlugin() {
    return {
        name: 'RMPlugin',
        onBrowserHydrateRenderContext: function (context, next) {
            var hydratedState = context.hydratedState, setAppData = context.setAppData;
            var resourceContext = hydratedState.resourceContext;
            setAppData({
                resourceContext: resourceContext,
            });
            return next(context);
        },
        onBrowserWrapRootElement: function (context, next) {
            var getAppData = context.getAppData, setRootElement = context.setRootElement;
            var resourceContext = getAppData().resourceContext;
            setRootElement(function (RootElement) {
                var ResourceHOC = function (_a) {
                    var children = _a.children;
                    return (React.createElement(resource_context_1.ResourceContextProvider, { resourceContext: resourceContext },
                        React.createElement(RootElement, null, children)));
                };
                return ResourceHOC;
            });
            return next(context);
        },
    };
}
exports.default = ResourceContextPlugin;
//# sourceMappingURL=browser.js.map